<template>
    <BasicHeader pretitle="aqfer Marketing Data Platform" title="Production Jobs" />
    <div class="container-fluid">
        <input-field v-if="sandBoxListOptions.length > 1" label="Choose a Job Environment" type="select"
            :options="sandBoxListOptions" v-model="selectedSandbox" class="mb-0" />
        <div class="tab-container" v-if="!loading && selectedSandbox">
            <nav-header :navItems="[
                {
                    name: 'Jobs',
                    link: {
                        name: 'Jobs',
                        params: {
                            sandboxId: `${selectedSandbox}`
                        },
                    },
                },
                {
                    name: 'Pipelines',
                    link: {
                        name: 'Pipelines',
                        params: {
                            sandboxId: `${selectedSandbox}`
                        },
                    },
                }
            ]" :breadcrumbTitle="false">
            </nav-header>
            <div class="">
                <router-view :selectedSandbox="selectedSandbox"></router-view>
            </div>
        </div>
        <div v-else-if="!loading && !sandBoxListOptions.length" class="container-fluid">
            <div class="alert alert-secondary" role="alert">
                No Sandboxes available!
            </div>
        </div>
    </div>
</template>

<script>
import BasicHeader from '../../components/BasicHeader.vue';
import InputField from "../../components/InputField.vue";
import NavHeader from "../../components/NavHeader.vue";
export default {
    components: { NavHeader, BasicHeader, InputField },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        selectedSandbox: {
            get() {
                return this.$store.state.sandbox.currentSandbox;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch('sandbox/setCurrentSandbox', value);
                    if (this.$route.name == "Pipelines") {
                        this.$router.push({
                            name: "Pipelines",
                            params: {
                                sandboxId: `${value}`
                            },
                        });
                    } else {
                        this.$router.push({
                            name: "Jobs",
                            params: {
                                sandboxId: `${value}`
                            },
                        });
                    }
                }
            }
        },
        sandBoxListOptions() {
            let prodAndProdv2SandboxList = this.$store.state.sandbox.prodSandboxes.concat(this.$store.state.sandbox.prodV2Sandboxes);
            return prodAndProdv2SandboxList ? prodAndProdv2SandboxList.map((sandbox) => {
                return { "label": sandbox.name, "value": sandbox.name };
            }) : [];
        }
    },
    beforeMount() {
        this.loading = true;
        try {
            if (this.$route.path.indexOf('/items') == -1 && this.$route.path.indexOf('/pipelines') == -1) {
                this.$router.push({
                    name: "Jobs",
                    params: {
                        sandboxId: `${this.$store.state.sandbox.currentSandbox}`
                    },
                });
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.loading = false;
        }
    }
}
</script>

<style></style>